import { Injectable } from "@angular/core";
import { US_COUNTRY_CODE } from "../../../infrastructure/context/UserContext";
import { formatAddress } from "../../../utilities/AddressUtility";
import { Property } from "../models/Property";
import { CountryService } from "../../../shared/reference/country.service";
import { getCountryCodeFromCountryId } from "../../../utilities/CountryUtility";

@Injectable({ providedIn: 'root' })
export class PropertyHelper {

    constructor(private countryService: CountryService) {}

    async getFormattedPropertyAddress(property?: Property): Promise<string> {
        if (!property) {
            return '';
        }
    
        const countries = await this.countryService.getCountries();
    
        const {
            address_line_1,
            address_line_2,
            city,
            state,
            postal_code
        } = property.address;
    
        const countryCode = getCountryCodeFromCountryId(countries, property.address.country_id);
    
        return formatAddress({
            addressLine1: address_line_1,
            addressLine2: address_line_2,
            city,
            province: state,
            postalCode: postal_code,
            countryCode: countryCode ?? US_COUNTRY_CODE
        });
    }
}